import programArchiveDetail from './Main'

const route = {
  path: '/archive/program/:year/:categoryName/:name',
  name: 'programArchiveDetail',
  meta: {
    title: 'Archive - A D M A N 2 0 1 9'
  },
  component: programArchiveDetail
}

export default route
